var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":("b2b-modal-pdfviewer-" + (this.randomId)),"size":"lg","centered":"","scrollable":"","hide-footer":true}},[_c('vue-pdf-app',{attrs:{"pdf":_vm.pdfSrc}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }